module.exports = __webpack_public_path__ + "static/media/Machine Design.adde9b3a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MECH/Machine Design.pdf
// module id = 139
// module chunks = 0